import { Layout, theme } from 'antd';
import SiderComponent from '../Sider/Sider';
import Headercomponent from '../Header/Headercomponent';
import './Home.css';
import CaseCategory from '../CaseCategory/CaseCategory';
import FooterComponent from '../Footer/FooterComponent';
import Dashboard from '../Dashboard/Dashboard';
import Clients from '../Clients/Clients';
import CaseStudy from '../CaseStudy/CaseStudy';
import Cases from '../Cases/Cases';
import Login from '../../pages/Login';
import PrivateRoute from '../../components/PrivateRoute';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';

const { Content } = Layout;

const Home = () => {
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <SiderComponent />
                <Layout>
                  <Headercomponent />
                  <Content style={{ padding: '16px' }}>
                    <Routes>
                      <Route
                        index
                        element={<Navigate to="/dashboard" replace />}
                      />
                      <Route path="/dashboard" element={<Dashboard />} />
                      <Route path="/clients" element={<Clients />} />
                      <Route path="/case-category" element={<CaseCategory />} />
                      <Route path="/case-study" element={<CaseStudy />} />
                      <Route path="/cases" element={<Cases />} />
                    </Routes>
                  </Content>
                  <FooterComponent />
                </Layout>
              </Layout>
            </PrivateRoute>
          }
        />

        {/* 404 fallback */}
        <Route path="*" element={<h1>404 - Not Found</h1>} />
      </Routes>
    </Router>
  );
};

export default Home;
